import {
    Switch,
    Route,
    withRouter
  } from "react-router-dom";
  import React, {Component} from "react";
  import './abckana-styles.css';
  class ABCKanaPrivacy extends Component {
    constructor(props) {
      super(props);
  }
    render() {
      return (
        <div className="ABCKanaPrivacy">
            <div class="hero"></div>
            <div class="container">
                <div class="logo">
                    <img src="./abckana_logo.png" alt="ABCKana iOS App"></img>
                    <br></br>
                    <img src="./home＿1284x2778.png" a="" t="App Screenshots"></img>
                </div>
                <div class="content">
                    <h2>Privacy Policy</h2>
                    <p>Protecting your private information is our priority. This Statement of Privacy applies to KesterSoftware.com and ABCかな and governs data collection and usage. For the purposes of this Privacy Policy, unless otherwise noted, all references to KesterSoftware.com include KesterSoftware.com and ABCかな. The ABCかな website is a Education app. By using the ABCかな app, you consent to the data practices described in this statement.</p>
            
                    <h3>Collection of your Personal Information</h3>
                    <p>We do not collect any personal information about you unless you voluntarily provide it to us. However, you may be required to provide certain personal information to us when you elect to use certain products or services available on the Site. These may include: (a) registering for an account on our Site; (b) entering a sweepstakes or contest sponsored by us or one of our partners; (c) signing up for special offers from selected third parties; (d) sending us an email message; (e) submitting your credit card or other payment information when ordering and purchasing products and services on our Site. To wit, we will use your information for, but not limited to, communicating with you in relation to services and/or products you have requested from us. We also may gather additional personal or non-personal information in the future.</p>

                    <h3>Sharing Information with Third Parties</h3>
                    <p>ABCかな does not sell, rent or lease its customer lists to third parties.
 
 ABCかな may share data with trusted partners to help perform statistical analysis, send you email or postal mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information except to provide these services to ABCかな, and they are required to maintain the confidentiality of your information.
  
 ABCかな may disclose your personal information, without notice, if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on ABCかな or the site; (b) protect and defend the rights or property of ABCかな; and/or (c) act under exigent circumstances to protect the personal safety of users of ABCかな, or the public.</p>

                    <h3>Automatically Collected Information</h3>
                    <p>Information about your computer hardware and software may be automatically collected by ABCかな. This information can include: your IP address, browser type, domain names, access times and referring website addresses. This information is used for the operation of the service, to maintain quality of the service, and to provide general statistics regarding use of the ABCかな website.</p>

                    <h3>Right to Deletion</h3>
                    <p>Subject to certain exceptions set out below, on receipt of a verifiable request from you, we will:
•	Delete your personal information from our records; and
•	Direct any service providers to delete your personal information from their records.</p>

<p><br></br></p>
                    <p>For ABCかな feedback, suggestions, or to report a problem, please contact <a href="mailto:kesterSoftware@gmail.com">Our Development Team</a>.</p>
                    
                    
                    <p><br></br></p>
                
                </div>
            </div>
        </div>

      );
    }
  }
  export default ABCKanaPrivacy;